import { BaseOption } from 'ui/selectv2/types';
import { LIST_MEMBERSHIP, USER_LIST_MEMBERSHIP } from 'utils/fieldConstants';
import {
  useFieldFacetTypeaheadOptions,
  useListMembershipOptions,
  useUserMappingOptions,
} from '../../hooks';
import { ValueType } from '../../../../types';
import { useMultiSelectInputContext } from '../../contexts';
import { useConditionState } from '../../../../hooks';

export const useMultiSelectBaseOptions = (
  valueType: ValueType,
): {
  options: BaseOption<string>[];
  isLoading: boolean;
} => {
  const [{ field }] = useConditionState();
  const { isFacetsLoading, isUserMappingsLoading, isListsLoading } = useMultiSelectInputContext();
  const userMappingOptions = useUserMappingOptions();
  const fieldFacetOptions = useFieldFacetTypeaheadOptions();
  const listMembershipOptions = useListMembershipOptions();

  switch (field) {
    case LIST_MEMBERSHIP:
    case USER_LIST_MEMBERSHIP:
      return { options: listMembershipOptions, isLoading: isListsLoading };
    default:
      switch (valueType) {
        case ValueType.Contact:
          return { options: userMappingOptions, isLoading: isUserMappingsLoading };
        case ValueType.Custom:
          return { options: fieldFacetOptions, isLoading: isFacetsLoading };
        default:
          return { options: [], isLoading: false };
      }
  }
};
